<div class="row">
  <div class="col-3">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Buscar posto</mat-label>
      <input matInput placeholder="Digite código ou nome" [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange($event)">
    </mat-form-field>
  </div>
  <div class="col-7">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Selecione o posto</mat-label>
      <mat-select [(ngModel)]="selectedCodPosto"

        [(value)]="selectedCodPosto" (selectionChange)="onSelectChange($event.value)">
        <mat-option *ngFor="let posto of filteredPostos" [value]="posto">
          {{ posto.codPosto }} - {{ posto.nomePosto }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-2">

    <button title="Buscar preços de combustíveis do posto selecionado" type="button" (click)="enviarPostoSelecionado()"
      class="btn btn-primary btn1">

      Buscar Preços
    </button>
  </div>
</div>